module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Communication/Chat-smile-a7d4822abac87ddfdd8b72703a5b4af4.svg";